<template>
	<div class="menu-quantity-buttons">
		<div class="shortcuts" v-if="shortcutMode">
			<div class="shortcut" :class="{selected: currentValue === 0}" @click="changedValue(0)">0</div>
			<div class="shortcut" :class="{selected: currentValue === 1}" @click="changedValue(1)">1</div>
			<div class="shortcut" :class="{selected: currentValue === 2}" @click="changedValue(2)">2</div>
			<div class="shortcut" :class="{selected: currentValue === 3}" @click="changedValue(3)">3</div>
			<div class="shortcut" @click="activateQuantityMode">+</div>
		</div>
		<div class="quantity" v-else>
			<MenuQuantity class="input-quantity" :value="currentValue" @changed-value="changedValue" :min="min" :max="max" />
		</div>
	</div>
</template>

<script>
import MenuQuantity from "@/new-menu/components/generic/MenuQuantity.vue";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	props: {
		min: {type: Number, default: 1},
		max: {type: Number, default: 99},
	},
	name: "MenuQuantityButtons",
	components: {MenuQuantity},
	emit: ['changed-value'],
	data() {
		return {
			shortcutMode: true,
			currentValue: 0
		}
	},
	methods: {
		changedValue(value) {
			this.currentValue = value;
			this.$emit('changed-value', value);
		},
		activateQuantityMode() {
			this.shortcutMode = false;
			this.currentValue = 4;
		}
	}
}
</script>

<style scoped lang="scss">
.menu-quantity-buttons {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;

	.shortcuts {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: var(--padding-horizontal-s);

		.shortcut {
			flex: 1;
			height: 40px;
			border-radius: var(--rounded-corner);
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: var(--theme-bg1-color);
			color: var(--theme-txt1-color);
			cursor: pointer;
			border: 1px solid var(--business-color-alpha60);
			transition: background-color 0.3s, color 0.3s, border-color 0.3s;

			&:hover {
				background-color: var(--business-color-alpha20);
				color: var(--business-text-color);
			}

			&.selected {
				background-color: var(--business-color-alpha40);
				color: var(--business-text-color);
				border: 1px solid var(--business-color);
			}
		}
	}

	.quantity {
	}
}
</style>